export default __webpack_public_path__ + "static/media/menu-btn.f77ab618.png";